/* unplugin-vue-components disabled */import script from "./item.vue?vue&type=script&lang=jsx"
export * from "./item.vue?vue&type=script&lang=jsx"

import "./item.vue?vue&type=style&index=0&id=45c5bc06&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c5bc06"]])

export default __exports__